module.exports = __webpack_public_path__ + "static/media/rina-1.bef6572e.jpg";